/* LE SUPPORT METALLISE : LE CHOIX, LES COTES, ET LE RENDU 3D.
 *
 * ⛔ TROIS CHOSES CHANGENT QUAND ON PASSE AU METAL, ET AUCUNE N'EST COSMETIQUE :
 *   1. LES COTES NE SONT PAS LES MEMES. Papier : 21x30, 30x40, 50x70, 70x100. Metal : 15x20,
 *      20x30, 30x40. Un seul format commun, le 30x40. On REMPLACE donc la liste, on ne
 *      la filtre pas — filtrer laisserait quatre boutons sur cinq et donnerait a croire que le
 *      50x70 existe en metal.
 *   2. LE CADRE ET LE CROCHET DISPARAISSENT (Adrien, 27/08/2026 : « pas de cadre ou crochet en
 *      option »). Une plaque metal se pose au mur telle quelle ; proposer un cadre serait vendre
 *      un objet qui n'ira pas.
 *   3. LA BORDURE RESTE. Elle vit dans l'image, pas dans l'objet.
 *
 * ⛔⛔ ET LES COTES SE PRENNENT DANS LE PRODUIT, JAMAIS DANS CE FICHIER. Les valeurs de l'option
 * « Taille » sont ecrites par Shopify et traduites par Markets : « 30X40 » ici, mais la valeur
 * peut changer de casse ou de separateur. On lit donc les boutons presents et on les partage
 * sur leur PREFIXE, pose par le catalogue. Une liste de cotes en dur dans un asset serait fausse
 * le jour ou une cote bouge, et fausse en silence.
 */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ⛔ LE PREFIXE QUI DISTINGUE UNE COTE METAL D'UNE COTE PAPIER, A UN SEUL ENDROIT. Il est pose
     par le catalogue dans la valeur d'option (« Métal 30x40 »). Le changer ici sans le changer
     la-bas ferait disparaitre toutes les cotes metal SANS ERREUR : la liste serait vide et le
     client verrait « Choisissez une taille » sans aucune taille a choisir. */
  var PREFIXE_METAL = "Métal";

  function estCoteMetal(el) {
    var v = el.getAttribute("data-value") || el.getAttribute("value") || el.textContent || "";
    return v.indexOf(PREFIXE_METAL) === 0;
  }

  /* Les boutons de cote, quelle que soit la forme que le gabarit leur donne. */
  function coteBoutons() {
    var bloc = $(".pdp-option");
    if (!bloc) return [];
    return $$("[data-value], input[type=radio]", bloc);
  }

  function estMetal() {
    if (document.querySelector('[data-fixed-metal="true"]')) return true;
    var b = $('#pdp-support .pdp-support__btn[data-support="metal"]');
    return !!b && b.getAttribute("aria-pressed") === "true";
  }

  /* ⛔ ON MASQUE, ON NE SUPPRIME PAS. Retirer les boutons du document obligerait a les
     reconstruire au retour vers le papier, et c'est le gabarit qui sait les ecrire, pas nous.
     `hidden` laisse la verite du cote de Shopify. */
  function peindreLesCotes() {
    var metal = estMetal();
    var visibles = 0;
    coteBoutons().forEach(function (el) {
      var pour = el.closest ? (el.closest("label") || el.closest("button") || el) : el;
      var garde = estCoteMetal(el) === metal;
      pour.hidden = !garde;
      if (garde) visibles++;
      /* ⚠️ UNE COTE MASQUEE QUI RESTE COCHEE ENVERRAIT AU PANIER UNE VARIANTE QUE L'ECRAN NE
         MONTRE PLUS. On la decoche, et la fiche redemande « Choisissez une taille » : mieux vaut
         un choix a refaire qu'une commande sur un support qu'on n'a pas choisi. */
      if (!garde) {
        if (el.checked) el.checked = false;
        if (el.getAttribute && el.getAttribute("aria-pressed") === "true") {
          el.setAttribute("aria-pressed", "false");
        }
      }
    });
    return visibles;
  }

  /* Le cadre et le crochet n'existent pas en metal : on cache le bloc entier, pas seulement ses
     pastilles. Cacher les pastilles laisserait un titre « Cadre » suivi de rien. */
  function peindreLesSuppléments() {
    var metal = estMetal();
    /* ⛔⛔ UN ATTRIBUT SUR LA RACINE, ET UNE REGLE CSS — PAS UN `hidden` (Adrien, TROISIEME
       rappel : « il ne doit pas y avoir de cadre en option pour le displate »). J'avais pose
       `el.hidden = metal`, et je l'avais meme MESURE a `true`. Mais `syncUpsells()` de
       `product.js` tourne apres chaque clic de taille et REAFFICHE le bloc : mon `hidden` etait
       efface par le JavaScript d'en face, et le cadre revenait des qu'on choisissait une cote.
       Une regle de feuille, elle, ne se defait pas en posant une propriete.
       ⚠️ MESURER UNE FOIS NE SUFFIT PAS quand un autre script peut repeindre : il faut mesurer
       APRES le geste suivant. C'est ce que je n'avais pas fait, trois fois. */
    document.documentElement.setAttribute("data-support", metal ? "metal" : "papier");
    ["#pdp-up-frame", "#pdp-up-hook", "#pdp-up-crochet"].forEach(function (sel) {
      var el = $(sel);
      if (el) el.hidden = metal;
    });
    /* ⛔ PAS DE SUR MESURE EN METAL (Adrien, 27/08/2026 : « Il n'y a pas de sur mesure pour le
       displate je t'ai deja donne les tailles »). Les plaques s'achetent aux trois cotes du
       fournisseur : laisser la pastille ouvrirait un formulaire de dimensions libres sur un
       produit qui n'en accepte aucune, et la commande arriverait a l'atelier sans plaque
       possible.
       ⚠️ ON REFERME AUSSI LE PANNEAU S'IL ETAIT OUVERT : masquer la seule pastille laisserait le
       formulaire deplie au-dessous, avec ses champs, et le client le remplirait. */
    var sm = $("[data-sur-mesure]");
    if (sm) {
      var tuile = sm.closest ? (sm.closest("label") || sm) : sm;
      tuile.hidden = metal;
      if (metal && sm.getAttribute("aria-pressed") === "true") {
        sm.setAttribute("aria-pressed", "false");
        var panneau = $("#pdp-sur-mesure");
        if (panneau) panneau.hidden = true;
      }
    }
  }

  /* ---------- LA VUE « PAPIER » DEVIENT « DETAIL », ET C'EST UNE VIDEO ----------
     ⛔ POURQUOI (Adrien, 30/08/2026). Sur une plaque, le gros plan de `qual-01` montre la
     matiere du support CONCURRENT : la fiche vend de l'acier et illustre du papier. La vignette
     garde sa place dans la bande, mais elle montre la presse a chaud, et son libelle devient
     « Detail ».
     ⛔ ON NE TOUCHE PAS AU GABARIT, ON BASCULE. La meme fiche sert les deux supports et le
     client passe de l'un a l'autre sans rechargement : ce qui est ecrit en Liquid serait fige au
     rendu. L'etat d'origine est donc MEMORISE au premier passage et repose tel quel au retour au
     papier, plutot que reconstruit de memoire, ou l'on oublie toujours un attribut.
     ⚠️ `data-fixe` RESTE : cette vignette ne suit pas la photo du client, video ou pas. */
  var vignettePapierOrigine = null;

  function laVignettePapier() { return $('#pdp-thumbs .pdp-thumb[data-cle="papier"], .pdp--perso-metal .pdp-thumb[data-cle="papier"]'); }

  function basculerLaVignettePapier() {
    var b = laVignettePapier();
    if (!b) return;
    var item = b.closest(".pdp-thumb-item");
    var cap = item ? item.querySelector(".pdp-thumb__cap") : null;
    var video = $("#pdp-metal-video");
    if (!vignettePapierOrigine) {
      vignettePapierOrigine = {
        img: b.getAttribute("data-img"), zoom: b.getAttribute("data-zoom"),
        badge: b.getAttribute("data-badge"), aria: b.getAttribute("aria-label"),
        fond: b.style.backgroundImage, cap: cap ? cap.textContent : null,
      };
    }
    if (estMetal() && video) {
      var poster = video.getAttribute("poster");
      var titre = video.getAttribute("aria-label") || "";
      b.setAttribute("data-metal-video", "true");
      /* ⛔ `data-img` GARDE UNE IMAGE : c'est le poster. `product.js` peint la scene depuis cet
         attribut, et un attribut vide y ecrirait `url()` — un fond casse, sans erreur. Le poster
         est la premiere image de la video : la scene ne saute donc pas quand la video se lance
         par-dessus. */
      b.setAttribute("data-img", poster);
      b.setAttribute("data-zoom", poster);
      b.setAttribute("data-badge", titre);
      b.style.backgroundImage = "url(" + poster + ")";
      var libelle = (typeof window.__pdpLibelleDetail === "string" && window.__pdpLibelleDetail)
        || (cap ? cap.textContent : "");
      if (cap && window.__pdpLibelleDetail) cap.textContent = window.__pdpLibelleDetail;
      b.setAttribute("aria-label", cap ? cap.textContent : libelle);
    } else {
      var o = vignettePapierOrigine;
      b.removeAttribute("data-metal-video");
      if (o) {
        if (o.img) b.setAttribute("data-img", o.img);
        if (o.zoom) b.setAttribute("data-zoom", o.zoom);
        if (o.badge) b.setAttribute("data-badge", o.badge);
        if (o.aria) b.setAttribute("aria-label", o.aria);
        b.style.backgroundImage = o.fond;
        if (cap && o.cap !== null) cap.textContent = o.cap;
      }
    }
    peindreLaVideo();
  }

  /* ⛔ LA VIDEO NE SE MONTRE QUE SUR SA PROPRE VUE, ET SEULEMENT EN METAL. Laissee visible, elle
     recouvrirait l'oeuvre : `#pdp-main` est un fond, la video un element, et c'est elle qui
     gagne. On la retire donc de la scene des qu'une autre vignette est pressee.
     ⚠️ ELLE SE CHARGE AU PREMIER AFFICHAGE, PAS AU RENDU DE LA PAGE : `preload="none"` et une
     `src` posee ici. Une fiche papier ne telecharge jamais ce fichier. */
  function peindreLaVideo() {
    var video = $("#pdp-metal-video");
    if (!video) return;
    var b = laVignettePapier();
    var active = !!(estMetal() && b && b.getAttribute("aria-pressed") === "true");
    if (active) {
      var src = video.getAttribute("data-src");
      if (src && video.getAttribute("src") !== src) video.setAttribute("src", src);
      video.hidden = false;
      /* ⛔ LA LECTURE PEUT ETRE REFUSEE, ET UN REFUS N'EST PAS UNE ERREUR A REMONTER : la video
         est muette donc l'autoplay passe partout, mais un navigateur en economie d'energie peut
         encore dire non. Le poster reste alors affiche, et la vue garde du sens. */
      var joue = video.play();
      if (joue && typeof joue.catch === "function") joue.catch(function () {});
    } else {
      try { video.pause(); } catch (e) { /* pas encore de source : rien a mettre en pause */ }
      video.hidden = true;
    }
  }

  function peindre(garderVue) {
    /* ⚠️ ET DES LE PREMIER PASSAGE, papier compris : le bloc est remonte au-dessus du titre sur
       telephone quel que soit le support, et il y depasserait l'image des le chargement. */
    calerSurLImage();
    basculerLaVignettePapier();
    peindreLesCotes();
    /* ⛔ LE PRIX SE REFAIT APRES LE MASQUAGE, PAS AVANT. `cheapestVariant` lit les cotes
       VISIBLES : l'appeler avant que `peindreLesCotes` ait masque les autres rendrait le prix du
       support qu'on vient de quitter. L'ordre est la regle. */
    if (typeof window.__pdpMajPrix === "function") window.__pdpMajPrix();
    peindreLesSuppléments();
    if (window.__pdpPeindreContenuSupport) window.__pdpPeindreContenuSupport();
    var code = $("#pdp-support-code");
    if (code) code.value = estMetal() ? "metal" : "papier";
    /* ⚠️ PLUS DE NOTE A BASCULER : les deux phrases ont ete retirees du gabarit le 28/08/2026.
       On garde la boucle vide plutot que rien : si une precision revient un jour sous les tuiles,
       elle portera `data-note` et se basculera toute seule. */
    $$("#pdp-support [data-note]").forEach(function (n) {
      n.hidden = (n.getAttribute("data-note") === "metal") !== estMetal();
    });
    /* ⛔⛔ ET LA PHRASE SOUS LE PRIX SUIT LE SUPPORT (Adrien, 28/08/2026, capture a l'appui).
       La phrase du support par defaut restait affichee sous une plaque d'acier : la page
       contredisait la tuile choisie deux centimetres plus bas. Meme mecanique
       que les notes ci-dessus, meme attribut a une lettre pres, pour qu'il n'y ait qu'une facon
       de dire « ce texte appartient a ce support ».
       ⚠️ HORS DE `#pdp-support` : cette phrase vit sous le prix, pas sous les tuiles. Reutiliser
       la boucle du dessus l'aurait laissee de cote sans lever la moindre erreur.
       ⚠️ ET AUCUNE COPIE N'EST CITEE ICI, PAS MEME EN COMMENTAIRE : le banc refuse toute phrase
       de langue dans cet asset, commentaires compris, et il a raison — une phrase recopiee a
       cote du code derive de celle des locales sans que rien ne le signale. */
    $$("[data-valeur]").forEach(function (n) {
      n.hidden = (n.getAttribute("data-valeur") === "metal") !== estMetal();
    });
    /* ⛔⛔ ET LA PORTE DU COMPOSEUR EMPORTE LE SUPPORT (Adrien, 28/08/2026 : « le bouton
       "composer mon mur" si on clique depuis le metallise doit afficher les affiches de type et
       de prix metallise »). Le lien est ecrit par Liquid, qui ne voit PAS ce que le client vient
       de cliquer : le support est un etat de navigateur, pas une donnee de la page. C'est donc
       ici, au seul endroit qui sait, que l'adresse se met a jour.
       ⚠️ ON RETIRE AUSSI BIEN QU'ON AJOUTE : revenir au papier apres avoir vu le metal doit
       rendre un lien papier. Un parametre qu'on ne sait qu'ajouter colle a la page pour toute la
       visite, et le client repart en plaques sans l'avoir demande.
       ⚠️ `URL` AVEC UNE BASE : le href est relatif (« /pages/composition?… »), et `new URL` sans
       base leve sur une adresse relative — la porte du composeur aurait disparu de la fiche. */
    $$(".pdp-create__card, #pdp-format a[href]").forEach(function (a) {
      var brut = a.getAttribute("href");
      if (!brut) return;
      try {
        var u = new URL(brut, window.location.origin);
        u.searchParams.delete("metal");
        if (estMetal()) u.searchParams.set("support", "metal");
        else u.searchParams.delete("support");
        a.setAttribute("href", u.pathname + u.search + u.hash);
      } catch (e) { /* une adresse qu'on ne sait pas lire se laisse telle quelle */ }
    });
    /* ⛔ CHANGER DE SUPPORT CHANGE L'AFFICHE : meme geste que la bordure et le cadre, meme
       raison. Sur une vue Papier ou Detail, le client bascule en metal et ne voit rien. */
    if (!garderVue && !window.__pdpPersoMetal && window.__pdpMontrerLAffiche) window.__pdpMontrerLAffiche();
    peindreLaScene();
  }

  /* ⛔⛔ LA SCENE VIT DANS LA GALERIE, PAR-DESSUS L'IMAGE 1 (Adrien, 27/08/2026 : « l'apercu 3D
     ne doit pas etre ici mais dans la galerie avec le design par dessus » puis « choisir
     metallise remplace image 1 par vue 3d avec design par dessus »).
     J'avais choisi de ne PAS toucher la galerie : son rail de vignettes a une instabilite
     documentee dans `product.js` (« huit portes », 13/08/2026). Il a tranche, et il a raison —
     une plaque metal ne se juge pas dans une vignette de 200 px sous un bouton.

     ⛔ ON SUPERPOSE, ON NE REMPLACE PAS LE NOEUD. `#pdp-main` porte son image en
     `background-image`, son `data-zoom`, et huit chemins de `product.js` le lisent ou le
     redessinent. Le vider ou le remplacer casserait le zoom, le cadre, la bordure et les
     mesures. La toile se pose PAR-DESSUS, en absolu, et disparait avec le support papier :
     `#pdp-main` reste intact, et tout ce qui le lit continue de fonctionner.

     ⚠️ ELLE NE COUVRE QUE LA VUE DE L'OEUVRE. Sur une vue Papier ou Detail — des photos
     d'atelier prises sur une AUTRE affiche — la plaque n'a rien a montrer, et la recouvrir
     ferait croire que ces photos changent avec le support. `estVueOeuvre` le lit sur les
     attributs, jamais sur un libelle : les legendes existent en treize langues. */
  var scene = null;

  function scenePrete() {
    return !!(scene && (typeof scene.ready !== 'function' || scene.ready()));
  }

  /* ⛔⛔ MEME DEFINITION QUE `estVignetteOeuvre` DE `product.js`, AUX DEUX ATTRIBUTS PRES.
     Ma premiere version n'excluait que `data-fixe` : la plaque se posait donc PAR-DESSUS les
     mises en situation, et Adrien l'a vue flotter au milieu du salon (27/08/2026). Le
     commentaire de `product.js` prevenait pourtant : cette regle etait ecrite deux fois, et
     « trois copies d'une meme regle divergent au premier deplacement de vignette ». J'en ai
     fait une quatrieme, et elle a diverge tout de suite.
     ⚠️ ELLE NE PEUT PAS ETRE IMPORTEE : `estVignetteOeuvre` vit dans une fonction anonyme de
     `product.js` et n'est pas exposee. Le banc compare donc les DEUX textes et refuse l'ecart —
     c'est le seul lien qu'on puisse tenir.
     ⛔⛔⛔ ET LES MISES EN SITUATION ONT LEUR PLAQUE DEPUIS LE 30/08/2026. Ce commentaire disait
     jusqu'ici qu'elles « sont GENEREES cote serveur » et que « rien ici ne sait ou l'affiche se
     trouve dans la piece ». C'ETAIT FAUX, et cette phrase a servi deux fois a refuser la demande
     d'Adrien puis celle de Jonathan. Salon, Chambre et Cuisine sont assemblees DANS LE NAVIGATEUR :
     la photo de piece est un fond sur `#pdp-mockup`, et l'affiche est un ELEMENT — `#pdp-mockup-art`
     — pose en rectangle droit, sans perspective. Sa place n'a pas a etre devinee, elle est dans le
     document.
     ⚠️ CE QUI AVAIT PRODUIT LA CAPTURE N'ETAIT PAS L'IMPOSSIBILITE, C'ETAIT LA CIBLE : la toile
     etait posee en plein cadre sur `#pdp-main`, donc sur la PIECE ENTIERE, d'ou la plaque qui
     flottait au milieu du salon. Posee sur `#pdp-mockup-art`, elle epouse l'affiche au mur.
     ⚠️ ET LE GROS PLAN RESTE DEHORS, pour la raison ecrite plus bas : un cadrage serre n'est pas
     une plaque entiere. Seules les vues qui montrent l'oeuvre COMPLETE recoivent le vernis. */
  /* La vue montre l'affiche AU MUR : meme oeuvre entiere, meme rectangle droit, mais dans une
     piece. Elle merite donc le vernis, sur son propre element. */
  function estVueEnSituation() {
    var v = document.querySelector('.pdp-thumb[aria-pressed="true"]');
    return !!v && v.getAttribute("data-mockup") === "true";
  }

  /* ⛔⛔ L'HOTE SE CHOISIT, IL N'EST PLUS TOUJOURS `#pdp-main`. C'est tout ce qui separait « la
     plaque flotte au milieu du salon » de « la plaque est au mur » : le meme rendu, pose sur le
     rectangle de l'affiche au lieu du rectangle de la piece.
     ⚠️ ET LA TOILE SE MESURE ELLE-MEME A CHAQUE DESSIN (`toile.clientWidth`, `clientHeight` dans
     `displate-3d.js`) : la deplacer suffit, il n'y a aucune dimension a lui transmettre — y compris
     quand `positionMockup` change la largeur de l'affiche au changement de format. */
  function hoteVoulu() {
    return estVueEnSituation() ? $("#pdp-mockup-art") : $("#pdp-main");
  }

  function estVueOeuvre() {
    var v = document.querySelector('.pdp-thumb[aria-pressed="true"]');
    /* Aucune vignette pressee : on est au chargement, et la vue par defaut EST l'oeuvre. */
    if (!v) return true;
    /* ⛔⛔ ET LE GROS PLAN N'EST PAS LA PLAQUE (Adrien, 28/08/2026). La vignette « zoom » est un
       media produit dont le nom porte `-detail` : un DETAIL de l'oeuvre, pas l'oeuvre entiere.
       Elle n'a ni `data-fixe` ni `data-mockup` — elle passait donc les deux gardes, et la
       plaque se posait dessus en plein cadre. Mesure du 28/08 sur « Courbes alpines » : sur six
       vignettes, `zoom` etait la SEULE recouverte a tort. Sur une fiche sans gros plan, le
       defaut n'existe pas : c'est pourquoi il m'avait echappe.
       ⚠️ CETTE CONDITION NE REJOINT PAS `estVignetteOeuvre` DE `product.js`, ET C'EST VOULU. La
       ou cette fonction-la sert la bordure — et un gros plan de l'oeuvre EST de l'oeuvre, donc
       bordable —, celle-ci decide si l'on peut poser une plaque ENTIERE : un cadrage serre n'est
       pas une plaque entiere. Deux questions, deux reponses ; le banc le dit. */
    if (v.getAttribute("data-cle") === "zoom") return false;
    return !v.hasAttribute("data-fixe") && v.getAttribute("data-mockup") !== "true";
  }

  /* ⛔⛔ LE CHOIX DE SUPPORT NE DEPASSE PAS L'IMAGE (Adrien, 28/08/2026 : « les options ne
     doivent pas etre plus larges que l'image sur mobile »).
     Sur telephone le bloc est remonte au-dessus du titre : il herite alors de la largeur de la
     COLONNE D'ACHAT, tandis que l'image, elle, est bornee par sa hauteur et par son propre
     rapport. Les deux ne coincident donc jamais, et l'ecart grandit avec les affiches les plus
     hautes. Aucune regle de feuille ne peut le savoir : la largeur de l'image se MESURE.
     ⚠️ ON NE TOUCHE PAS A LA COLONNE, qui sert huit autres blocs : on borne ce bloc-ci, et on
     rend la main au-dela du point de bascule pour que l'ordinateur reste intact. */
  function calerSurLImage() {
    var bloc = $("#pdp-support");
    var main = $("#pdp-main");
    if (!bloc || !main) return;
    // Dans le bloc d'achat, le support suit la largeur des autres choix.
    if (bloc.closest('.pdp-buy--catalogue')) {
      bloc.style.maxWidth = '';
      bloc.style.marginLeft = '';
      bloc.style.marginRight = '';
      return;
    }
    if (window.innerWidth > 900) {
      bloc.style.maxWidth = "";
      bloc.style.marginLeft = "";
      bloc.style.marginRight = "";
      return;
    }
    var l = Math.round(main.getBoundingClientRect().width);
    if (l < 40) return;
    bloc.style.maxWidth = l + "px";
    bloc.style.marginLeft = "auto";
    bloc.style.marginRight = "auto";
  }
  window.addEventListener("resize", calerSurLImage);

  function peindreLaScene() {
    if (window.__pdpPersoMetal) {
      var blocPerso = $("#pdp-support-scene"), ouvrirPerso = $("#pdp-metal-open");
      if (blocPerso) blocPerso.hidden = false;
      if (ouvrirPerso) ouvrirPerso.hidden = typeof HTMLDialogElement === "undefined";
      return;
    }
    calerSurLImage();
    var main = $("#pdp-main");
    if (!main) return;
    var hote = $("#pdp-support-scene");
    if (!hote) return;
    /* ⛔ LA TOILE DEMENAGE UNE FOIS, DE SON BLOC D'ORIGINE VERS LA SCENE. Le gabarit la rend
       sous le choix — c'est la que Liquid connait l'image et le rapport — et elle rejoint la
       galerie au premier besoin. La rendre deux fois donnerait deux contextes WebGL pour une
       seule plaque. */
    /* ⛔⛔ DANS `#pdp-main`, PAS DANS `#pdp-stage`. La scene contient le cadre, la marge de
       bordure et les respirations : une toile posee dessus en `inset:0` couvre tout cela, et la
       plaque se retrouve a une taille qui n'est celle de rien. Dans `#pdp-main`, elle epouse
       EXACTEMENT la surface de l'affiche — c'est la que « l'affiche est incrustee dans la
       plaque » a un sens, parce que les deux occupent le meme rectangle.
       ⚠️ ET LA MEME REGLE DESIGNE `#pdp-mockup-art` EN MISE EN SITUATION : le rectangle de
       l'oeuvre, pas celui de la piece. */
    var cible = hoteVoulu() || main;
    if (hote.parentNode !== cible) cible.appendChild(hote);
    var metal = estMetal();
    var montrer = metal && (estVueOeuvre() || estVueEnSituation());
    hote.hidden = !montrer;
    var vignette = document.querySelector('.pdp-thumb[aria-pressed="true"]');
    var animer = montrer && (!vignette || vignette.getAttribute('data-cle') === 'media1');
    if (scene && scene.automatique) scene.automatique(animer);
    /* ⛔ L'IMAGE 1 S'EFFACE PENDANT QUE LA PLAQUE EST LA, et revient avec le papier. Superposer
       sans effacer laissait l'affiche visible autour de la plaque inclinee : deux objets pour un
       seul produit. On ne touche QUE l'image de fond — jamais le `position`, qui a blanchi la
       fiche le 27/08.
       ⚠️ ON EFFACE L'HOTE DU MOMENT, ET ON REND L'AUTRE : sans cela, revenir de la piece vers
       l'oeuvre laissait `#pdp-mockup-art` vide pour le reste de la visite — une affiche disparue
       du mur, sans erreur pour le dire. */
    var art = $("#pdp-mockup-art");
    if (main !== cible) main.classList.remove("pdp-main--plaque");
    if (art && art !== cible) art.classList.remove("pdp-main--plaque");
    cible.classList.toggle("pdp-main--plaque", montrer && scenePrete());
    hote.dataset.ready = String(scenePrete());
    /* ⛔⛔ EN METAL, LE CADRE DE LA GALERIE DISPARAIT (Adrien, 28/08/2026 : « je t'ai dit que les
       cadres ne sont pas une option avec le displate »). Le bloc d'achat du cadre etait bien
       masque ; ce qui restait, c'est la VUE « Encadrée » — et ce n'est pas une autre photo : la
       vignette `media1` porte la MEME image que `#pdp-main`, dessinee dans un cadre CSS
       (`data-framed` sur `.pdp-gallery__wrap`). On voyait donc une plaque d'acier posee dans une
       moulure, ce qui n'existe pas.
       ⛔ ET C'EST CE MEME CADRE QUI FAISAIT LE FOND #E5DBC8 : le passe-partout de
       `.pdp-frame__inner`. Le retirer resout les deux d'un coup — plus de moulure, plus de fond,
       et la plaque occupe exactement la place de l'image 1.
       ⚠️ ON REPOSE L'ETAT D'ORIGINE AU RETOUR AU PAPIER, jamais une valeur devinee : un cadre
       eteint pour toujours vaudrait mieux que rien, mais un cadre ALLUME sur une fiche qui n'en
       avait pas serait un defaut neuf. */
    var wrap = document.querySelector(".pdp-gallery__wrap");
    if (wrap) {
      if (montrer) {
        if (!wrap.hasAttribute("data-framed-avant")) {
          wrap.setAttribute("data-framed-avant", wrap.getAttribute("data-framed") || "");
        }
        wrap.setAttribute("data-framed", "false");
        /* ⛔⛔⛔ ET ON DONNE SON RAPPORT A LA SCENE, SINON ELLE PREND UN 3/4 QUI N'EST CELUI DE RIEN
           (Jonathan, 30/08/2026 : « sur le responsive tu vois l'image depasse sur la partie de droite
           de la product page »). `data-framed="false"` — que la ligne du dessus pose pour retirer la
           moulure — fait lire a `#pdp-stage` un `aspect-ratio: var(--acc-ar, 3/4)`, et PERSONNE ne
           definit cette variable sur une fiche affiche. Le repli s'appliquait donc : la scene passait
           de 0,69 a 0,75 de rapport, soit 75 pixels de plus en largeur pour la meme hauteur.
           ⚠️ CE N'ETAIT PAS QU'UN DEFAUT DE PETIT ECRAN, et c'est ce qui l'a rendu invisible : a partir
           de 1200 pixels la colonne a la place d'absorber ces 75 pixels, et il ne reste qu'une affiche
           un peu trop large — la meme faute, sans symptome. Mesure du 30/08 : 33 pixels dehors a 1010,
           123 a 993, ou l'affiche passait par-dessus le titre et le prix. En papier, aux memes
           largeurs, rien ne depassait.
           ⚠️ ET C'EST LA MEME REGLE QUE PARTOUT AILLEURS ICI : la plaque occupe EXACTEMENT la place de
           l'image 1. Une scene qui change de forme au clic sur « Metallise » dit au client que le
           produit n'a pas le meme cadrage selon son support, ce qui est faux. */
        var srcRap = document.querySelector("#pdp-support");
        var rap = parseFloat(srcRap && srcRap.getAttribute("data-ratio"));
        if (rap > 0) wrap.style.setProperty("--acc-ar", rap + " / 1");
      } else if (wrap.hasAttribute("data-framed-avant")) {
        /* ⚠️ ON REND LA VARIABLE COMME ON REND `data-framed` : la laisser posee ferait garder au
           papier un rapport calcule pour la plaque. Ici les deux valent 0,69, donc rien ne se verrait
           — jusqu'a la premiere fiche ou elles differeront. */
        wrap.style.removeProperty("--acc-ar");
        var avant = wrap.getAttribute("data-framed-avant");
        if (avant) wrap.setAttribute("data-framed", avant);
        else wrap.removeAttribute("data-framed");
        wrap.removeAttribute("data-framed-avant");
      }
    }
    if (!montrer) return;
    if (!scene && window.__displateMonter) {
      var src = $("#pdp-support");
      scene = window.__displateMonter($("#pdp-support-toile"),
        (src && src.getAttribute("data-image")) || "",
        parseFloat(src && src.getAttribute("data-ratio")) || 0.75);
      /* ⚠️ WebGL PEUT REFUSER : vieil appareil, pilote bloque, contexte perdu. On cache alors la
         toile au lieu de laisser un rectangle vide par-dessus l'affiche — le client verrait son
         oeuvre disparaitre. Le choix du support, lui, continue de vendre. */
      if (!scene) { hote.hidden = true; cible.classList.remove("pdp-main--plaque"); return; }
    }
    if (scene) scene.support(true);
    /* ⛔⛔ LE GESTE N'EXISTE QUE SUR LA GRANDE VUE (Jonathan, 30/08/2026 : « et sur les mur, enleve
       l'animation, laisse juste le reflet »). Une plaque accrochee au-dessus d'un canape qui pivote au
       passage du curseur se lit comme un defaut de la page ; la meme bascule sur la grande vue se lit
       comme un objet qu'on prend en main.
       ⚠️ ON LE REDIT A CHAQUE PEINTURE, jamais une seule fois au montage : la scene DEMENAGE d'un hote
       a l'autre au fil des vignettes, et un reglage pose au montage vaudrait pour la premiere vue
       seulement — le genre d'erreur qui ne se voit que si l'on change de vue dans le bon ordre. */
    if (scene && scene.geste) scene.geste(!estVueEnSituation());
    if (scene && scene.automatique) scene.automatique(animer);
    if (scene && scene.format) {
      var choisie = $('.pdp-option [data-value][aria-pressed="true"]');
      var dimensions = choisie && (choisie.getAttribute('data-value') || '').match(/(\d+)\s*[x×]\s*(\d+)/i);
      if (dimensions) {
        var paysage = parseFloat($('#pdp-support').getAttribute('data-ratio')) > 1;
        scene.format((paysage ? Math.min : Math.max)(Number(dimensions[1]), Number(dimensions[2])) * 10);
      }
    }
    hote.dataset.ready = String(scenePrete());
    cible.classList.toggle("pdp-main--plaque", montrer && scenePrete());
    var ouvrir3d = $('#pdp-metal-open');
    if (ouvrir3d) ouvrir3d.hidden = !scenePrete() || typeof HTMLDialogElement === 'undefined';
  }

  document.addEventListener('af:metal-ready', function (e) {
    if (e.target.id === 'pdp-support-toile') peindreLaScene();
  });

  /* ⚠️ PLUS DE BORDURE SUR LA PLAQUE (Adrien, 28/08/2026 : « retire l'option de bordure pour
     les displate »). Rien a masquer ici : `bordure-blanche.js` ne connait plus les cotes metal,
     `partImage` y rend `null`, et `applique()` retire le bloc entier de la fiche. L'option
     disparait donc a sa source, pas par une regle d'affichage posee par-dessus — c'est ce qui
     evite qu'elle reapparaisse le jour ou quelqu'un touche au CSS.
     Le rendu garde ses `part` et `fond` a leur valeur neutre : sans appelant, la plaque dessine
     l'oeuvre bord a bord, exactement comme avant que la bordure existe. */

  /* ⛔⛔ ET LES FLECHES DU CARROUSEL AUSSI (Adrien, 28/08/2026 : « les images zoom, detail et
     papier ne s'affichent pas »). Sur telephone il n'y a PAS de rail de vignettes : on change de
     vue avec `.pdp-fleche`, qui n'est pas une `.pdp-thumb`. Mon ecoute ne se declenchait donc
     jamais, la plaque restait posee sur chaque diapositive, et les photos d'atelier
     disparaissaient derriere elle — seul leur badge changeait, ce qui rendait le defaut
     incomprehensible.
     ⚠️ J'AVAIS VERIFIE SUR ORDINATEUR, ou le rail existe : le geste que je mesurais n'etait pas
     celui du client. Une vue mesuree sur un seul appareil ne dit rien de l'autre. */
  /* ⛔⛔⛔ ON ECOUTE LE RESULTAT, PLUS LE GESTE (Adrien, 28/08/2026 : « les images zoom, detail et
     papier ne s'affichent pas »).
     J'ai d'abord ecoute le clic sur `.pdp-thumb` : vrai sur ordinateur, faux sur telephone, ou
     l'on change de vue avec `.pdp-fleche`. J'ai donc ajoute la fleche — et le glissement au
     doigt restait dehors. A chaque porte ajoutee, il en restait une autre : c'est le signe qu'on
     ecoute la mauvaise chose.
     ⚠️ CE QUI DECIDE, C'EST `aria-pressed` SUR LE RAIL, quel que soit ce qui l'a change : clic,
     fleche, glissement, changement de variante, ou un chemin que je ne connais pas encore. Un
     observateur sur cet attribut ne peut pas etre contourne, et il n'aura pas a etre complete a
     la prochaine porte.
     ⚠️ ET IL SURVIT AU REDESSIN DU RAIL : on observe le CONTENEUR en `subtree`, pas les boutons,
     qui sont remplaces a chaque changement de variante. */
  if (typeof MutationObserver === "function") {
    var rail = document.querySelector(".pdp-thumbs") || document.body;
    new MutationObserver(function (lots) {
      for (var i = 0; i < lots.length; i++) {
        var c = lots[i].target;
        if (c && c.classList && c.classList.contains("pdp-thumb")) { peindreLaScene(); peindreLaVideo(); return; }
      }
    }).observe(rail, { subtree: true, attributes: true, attributeFilter: ["aria-pressed"] });
  }


  function choisirSupport(b) {
    var change = b.getAttribute("aria-pressed") !== "true";
    $$("#pdp-support .pdp-support__btn").forEach(function (x) {
      x.setAttribute("aria-pressed", String(x === b));
    });
    /* ⛔ CHANGER DE SUPPORT EFFACE LA TAILLE, DANS L'ETAT ET PAS SEULEMENT A L'ECRAN. Sans cela
       le prix restait celui de la plaque sur une fiche revenue au papier : `peindreLesCotes`
       retire l'`aria-pressed`, mais `selected` de `product.js` gardait la valeur, et
       `formatChosen()` restait vrai. Le DOM n'est pas l'etat.
       ⚠️ SEULEMENT SUR UN VRAI CHANGEMENT : recliquer le support deja actif ne doit rien
       oublier, sinon un clic sans consequence effacerait le choix du client. */
    if (change && window.__pdpOublierLeFormat) window.__pdpOublierLeFormat();
    peindre();
    if (change) {
      var tailles = $(".pdp-buy--catalogue .pdp-option");
      if (tailles) tailles.scrollLeft = 0;
    }
  }

  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var b = e.target.closest("#pdp-support .pdp-support__btn");
    if (b) choisirSupport(b);
  });

  /* ⚠️ LA LIGNE DES COTES EST REDESSINEE A CHAQUE CHANGEMENT DE VARIANTE : sans cet
     observateur, un retour a une autre cote reafficherait les boutons papier alors que le
     support est reste au metal. C'est le meme piege que la marge de bordure, mesure le 17/08. */
  if (typeof MutationObserver === "function") {
    var bloc = $(".pdp-option");
    if (bloc) {
      new MutationObserver(function (changements) {
        if (changements.some(function (c) { return c.type === 'childList'; })) peindreLesCotes();
        if (estMetal()) peindreLaScene();
      }).observe(bloc, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed'],
      });
    }
  }

  /* ⛔⛔ ON ATTEND `DOMContentLoaded`, ET « complete » EST LE SEUL CAS QUI PASSE OUTRE.
     Le piege est precis : un script `defer` s'execute quand `readyState` vaut deja
     « interactive ». Le test habituel `=== "loading"` est donc FAUX ici — il ferait peindre
     immediatement, et `product.js` n'aurait pas encore tourne. `window.__pdpMontrerLAffiche`
     serait absent, le garde `if (window...)` avalerait l'appel, et la galerie cesserait
     simplement de revenir sur l'affiche : une panne SANS ERREUR.
     ⚠️ CE N'EST PAS THEORIQUE : ce snippet est rendu dans la colonne d'achat, donc AVANT
     `product.js` qui vit en pied de section. L'ordre du document nous est defavorable, et c'est
     l'evenement qui le corrige — il ne se declenche qu'une fois TOUS les `defer` executes. */
  function initialiserSupport() {
    var demande, arrivee = null;
    try {
      var params = new URL(window.location.href).searchParams;
      demande = params.get("metal") === "y" || params.get("support") === "metal";
      /* Les offres des moteurs portent ?variant=. Retrouver le support et la cote
         de cette offre sans imposer de format aux visites sans variante explicite. */
      if ($(".pdp-buy--catalogue")) {
        arrivee = (window.__pdpVariants || []).find(function (v) {
          return String(v.id) === params.get("variant") && v.available !== false;
        }) || null;
        if (arrivee) {
          var valeur = arrivee.option1 || (arrivee.options || [])[0] || "";
          var supportVariante = valeur.indexOf(PREFIXE_METAL) === 0;
          if (demande && !supportVariante) arrivee = null;
          else if (params.get("support") === "papier" && supportVariante) arrivee = null;
          else demande = supportVariante;
        }
      }
    } catch (e) { demande = false; }
    var metal = demande && $('#pdp-support .pdp-support__btn[data-support="metal"]');
    if (metal) choisirSupport(metal);
    else peindre(true);
    if (arrivee) {
      var option = arrivee.option1 || (arrivee.options || [])[0];
      var bouton = coteBoutons().find(function (b) {
        var parent = b.closest ? (b.closest("label") || b.closest("button") || b) : b;
        return b.getAttribute("data-value") === option && !parent.hidden;
      });
      if (bouton && bouton.getAttribute("aria-pressed") !== "true") bouton.click();
    }
  }

  if (document.readyState === "complete") {
    initialiserSupport();
  } else {
    document.addEventListener("DOMContentLoaded", initialiserSupport);
  }
})();
